import styled from "styled-components";
import {
  BRAND,
  BRAND_LIGHT,
  GRAY_LIGHT,
  WHITE
} from "@streeteasy/design-system/colors";

import { smallScreen } from "src/shared/constants/screenSizes";

export const OuteastLogo = styled.img`
  margin: 50px 0 16px;
  width: 113px;
`;

export const SocialDivider = styled.div`
  background: ${GRAY_LIGHT};
  height: 1px;
  margin: 0 auto;
  max-width: 502px;
  width: 100%;
`;

export const SocialIcons = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 40px 0 50px;
`;

export const SocialIconsSection = styled.section`
  background-color: ${WHITE};
  padding: 48px 40px 56px;
  text-align: center;

  @media screen and (max-width: ${smallScreen}px) {
    padding: 48px 24px;
  }
`;

export const SocialLink = styled.a`
  font-size: 0;

  svg path {
    fill: ${BRAND};
    transition: 250ms;
  }

  &:hover svg path {
    fill: ${BRAND_LIGHT};
  }

  &:not(:last-child) {
    margin-right: 40px;
  }
`;

export const OuteastLink = styled.a`
  font-size: 0;
`;
